import {
  MOBILE_HAND_CAROUSEL_AVAILABLE_WIDTH_PX,
  MOBILE_HAND_CAROUSEL_LANE_LEFT_PAD_PX,
  MOBILE_HAND_CARD_BASE_WIDTH_PX,
  MOBILE_HAND_CARD_SCALE,
} from './mobileBattleLayoutOffsets';

export { MOBILE_HAND_CARD_SCALE };
export const MOBILE_HAND_CARD_BASE_WIDTH = MOBILE_HAND_CARD_BASE_WIDTH_PX;
export const MOBILE_HAND_CARD_BASE_HEIGHT = 100;

export function getMobileHandScaledCardWidth(
  scale = MOBILE_HAND_CARD_SCALE
) {
  return MOBILE_HAND_CARD_BASE_WIDTH * scale;
}

/**
 * Lane runs prep/accord column (+ clearance) → drone edge. Full spread at max hand size;
 * smaller hands stay right-aligned inside the lane.
 */
export function computeMobileHandCarouselLayout(
  cardCount,
  {
    scale = MOBILE_HAND_CARD_SCALE,
    availableWidth = MOBILE_HAND_CAROUSEL_AVAILABLE_WIDTH_PX,
    laneLeftPad = MOBILE_HAND_CAROUSEL_LANE_LEFT_PAD_PX,
  } = {}
) {
  if (!Number.isFinite(cardCount) || cardCount < 0) {
    throw new Error('computeMobileHandCarouselLayout: cardCount must be a non-negative number');
  }
  if (!Number.isFinite(availableWidth) || availableWidth <= 0) {
    throw new Error('computeMobileHandCarouselLayout: availableWidth must be a positive number');
  }
  if (!Number.isFinite(laneLeftPad) || laneLeftPad < 0) {
    throw new Error('computeMobileHandCarouselLayout: laneLeftPad must be a non-negative number');
  }

  const scaledCardWidth = getMobileHandScaledCardWidth(scale);
  const scaledCardHeight = MOBILE_HAND_CARD_BASE_HEIGHT * scale;
  const maxSpacing = scaledCardWidth + 4;
  const usableWidth = Math.max(scaledCardWidth, availableWidth - laneLeftPad);

  if (cardCount <= 1) {
    const totalCardsWidth = scaledCardWidth;
    return {
      scaledCardWidth,
      scaledCardHeight,
      cardSpacing: 0,
      totalCardsWidth,
      startOffset: Math.max(laneLeftPad, availableWidth - totalCardsWidth),
    };
  }

  const fitSpacing = (usableWidth - scaledCardWidth) / (cardCount - 1);
  const cardSpacing = Math.min(maxSpacing, fitSpacing);
  const totalCardsWidth = (cardCount - 1) * cardSpacing + scaledCardWidth;
  const startOffset = Math.max(laneLeftPad, availableWidth - totalCardsWidth);

  return {
    scaledCardWidth,
    scaledCardHeight,
    cardSpacing,
    totalCardsWidth,
    startOffset,
  };
}
